import { render } from "./tooltip-example.vue?vue&type=template&id=0b70a0a2"
import script from "./tooltip-example.vue?vue&type=script&lang=js"
export * from "./tooltip-example.vue?vue&type=script&lang=js"

import "./tooltip-example.vue?vue&type=style&index=0&id=0b70a0a2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__